import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetApiRequest } from '../../services/api';

export const fetchPendingExperiences = createAsyncThunk(
  'pendingExperiences/fetchPending',
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await GetApiRequest("admin/experiences/pending", {
        page,
        limit,
      });

      const data = response?.data?.data || {};
      const experiencesList = data.experiences || [];
      const pagination = data.pagination || { page: 1, limit: 10, total: 0, pages: 1 };

      return {
        experiences: experiencesList,
        pagination: {
          pages: pagination.pages || 1,
          page: pagination.page || 1,
          total: pagination.total || 0
        }
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Failed to load pending experiences');
    }
  }
);

const initialState = {
  experiences: [],
  loading: false,
  error: null,
  pagination: {
    pages: 1,
    page: 1,
    total: 0
  },
  currentPage: 1,
  limit: 10,
  hasLoaded: false,
  lastFetchedPage: null,
  lastFetchedLimit: null
};

const pendingExperiencesSlice = createSlice({
  name: 'pendingExperiences',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingExperiences.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingExperiences.fulfilled, (state, action) => {
        state.loading = false;
        state.experiences = action.payload.experiences;
        state.pagination = action.payload.pagination;
        state.hasLoaded = true;
        state.lastFetchedPage = action?.meta?.arg?.page ?? state.pagination.page;
        state.lastFetchedLimit = action?.meta?.arg?.limit ?? state.limit;
      })
      .addCase(fetchPendingExperiences.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setCurrentPage, clearError } = pendingExperiencesSlice.actions;
export default pendingExperiencesSlice.reducer;
